import { coreTagsGetAsyncSlice } from './get';
import { CoreTagsName } from './name';
import { createUpdateSyncSlice } from '@sonar-software/xuder';
import { PatchTagRequest } from '@api';

export const coreTagsUpdateSyncSlice = createUpdateSyncSlice({
	name: CoreTagsName,
	state: coreTagsGetAsyncSlice.asyncState,
	transform: (action: PatchTagRequest, state = []) => {
		const index = state.findIndex((x) => x.id === action.id);

		if (index === -1) {
			return state;
		}

		const target = state[ index ];

		if (!target) {
			return state;
		}

		return [
			...state.slice(0, index),
			{
				...target,
				...action
			},
			...state.slice(index + 1)
		].sort((a, b) => a.name.localeCompare(b.name));
	}
});
